export function parseOfficialLinks(officialLinks: unknown): string[] {
  if (!Array.isArray(officialLinks)) {
    return [];
  }

  return officialLinks
    .filter((item): item is string => typeof item === 'string')
    .map((item) => item.trim())
    .filter(Boolean);
}

export function parseMeUrls(meUrls: unknown): string[] {
  if (!Array.isArray(meUrls)) {
    return [];
  }

  return meUrls
    .filter((item): item is string => typeof item === 'string')
    .map((item) => normalizeMeUrlDomain(item))
    .filter(Boolean);
}

export function normalizeMeUrlDomain(domain: string): string {
  return domain.trim().replace(/^www\./i, '').toLowerCase();
}
